/* @flow */
import Button from 'components/Button';
import Groups from 'collections/Groups';
import CopySubscriberDialog from './CopySubscriberDialog';
import ModalTrigger from 'components/ModalTrigger';
import PropTypes from 'prop-types';
import * as React from 'react';
import Relationship from 'entities/Relationship';
import cx from 'classnames';
import './styles/CopySubscriberButton.scss';

class CopySubscriberButton extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    relationship: PropTypes.instanceOf(Relationship).isRequired,
    size: PropTypes.oneOf(['normal', 'small']),
  };

  static defaultProps = {
    size: 'normal',
  };

  getUnjoinedOwnedGroups = () => {
    const { relationship } = this.props;
    const subscriptions = relationship.getSubscriptionsToMe();

    if (!this.props.groups) {
      return [];
    }

    return new Groups(
      this.props.groups.filter(group => {
        return !subscriptions.some(subscription => {
          return subscription.getGroupId() === group.id;
        });
      })
    );
  };

  renderCopySubscriberDialog = () => {
    return <CopySubscriberDialog relationships={[this.props.relationship]} />;
  };

  render() {
    const unjoinedGroups = this.getUnjoinedOwnedGroups();
    const hasUnjoinedGroup = unjoinedGroups.length > 0;

    let tooltip;
    if (!hasUnjoinedGroup) {
      const { relationship } = this.props;
      const subscriber = relationship.getRelatedUser();
      const name = subscriber.getName();
      tooltip = `${name} has joined all of your classes.`;
    }

    let button = (
      <Button
        {...this.props}
        className={cx(
          'CopySubscriberButton',
          {
            'CopySubscriberButton-small': this.props.size === 'small',
            'CopySubscriberButton-disabled': !hasUnjoinedGroup,
          },
          this.props.className
        )}
        color="brand"
        level="text"
        size="small"
        tooltip={tooltip}
        tooltipPlacement="bottom">
        Copy to another class
      </Button>
    );

    if (hasUnjoinedGroup) {
      button = <ModalTrigger modal={this.renderCopySubscriberDialog()}>{button}</ModalTrigger>;
    }

    return button;
  }
}

export default CopySubscriberButton;
